var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 21.5,
    height: 21.5,
    rx: 1.00824,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.952637 17.1573L6.18971 10.2225C6.53616 9.76374 7.22247 9.75549 7.57986 10.2058L12.43 16.3169C12.7749 16.7516 13.4314 16.7619 13.7898 16.3382L16.8397 12.7326C17.1935 12.3144 17.8393 12.318 18.1884 12.74L21.8421 17.1573",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7154 6.96466C19.7154 7.5463 19.5398 8.05909 19.273 8.41833C19.0061 8.77759 18.6652 8.96537 18.3196 8.96537C17.974 8.96537 17.6331 8.77759 17.3662 8.41833C17.0994 8.05909 16.9238 7.5463 16.9238 6.96466C16.9238 6.38302 17.0994 5.87023 17.3662 5.51099C17.6331 5.15174 17.974 4.96395 18.3196 4.96395C18.6652 4.96395 19.0061 5.15174 19.273 5.51099C19.5398 5.87023 19.7154 6.38302 19.7154 6.96466Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.703297
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/gallery-icon.0a2b6e492c05b731ec9a43028831b6b9.svg";
export { ForwardRef as ReactComponent };